import { render, staticRenderFns } from "./NileCreditApplicationView.vue?vue&type=template&id=32fb9209&"
import script from "./NileCreditApplicationView.vue?vue&type=script&lang=js&"
export * from "./NileCreditApplicationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports